/**
 * @Description 封装在modal里的im
 */
import { FC } from 'react';
import IMIframe from '../ImIframe';
import styles from './index.module.less';
import { CloseOutlined } from '@ant-design/icons';

const ImModal:FC<any> = ({
  setShowIM,
  contactUrl,
  zIndex = 10000
}) => {
  return (
    <div className={styles['im-modal']} style={{ zIndex: zIndex }}>
      <div className={styles['close-box']} onClick={() => { setShowIM(false); }}>
        <CloseOutlined className={styles['icon']}/>
      </div>
      <IMIframe src={contactUrl}/>
    </div>
  );
};

export default ImModal;
